import type { Column } from '@/types'
import { memo } from 'react'
import { getColumnKeyLabels } from '@/utils/columnKeys'

interface ColumnKeyIconProps {
  column: Column
}

function getTone(keyType: string) {
  if (keyType === 'PK') return '#D97706'
  if (keyType === 'FK') return '#4F46E5'
  if (keyType === 'UQ') return '#059669'
  return 'transparent'
}

export const ColumnKeyIcon = memo(function ColumnKeyIcon({ column }: ColumnKeyIconProps) {
  const labels = getColumnKeyLabels(column)
  if (!labels.length) return null
  return (
    <span className="inline-flex items-center gap-0.5">
      {labels.map((label) => (
        <span
          key={label}
          style={{
            fontSize: 9,
            lineHeight: 1,
            fontWeight: 700,
            letterSpacing: 0,
            color: getTone(label),
          }}
        >
          {label}
        </span>
      ))}
    </span>
  )
})
